import * as pxp from '../lib/pxp'

// https://www.msmaster.qa.paypal.com/elmo/experiment/126123
// https://admin.paypalinc.com/elmo/experiment/107118
export function hasVisaPlusTreatment() {
  return pxp.isTreatment('Trmt_p2p_web_visa_plus_experience')
}
